<template>
  <div class="userinfo-container">
    <el-form :inline="true" :model="filters">
      <el-form-item>
        <el-button size="small" type="success" v-on:click="handleCreate">新增</el-button>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input size="small" v-model="filters.search" placeholder="请输入查询关键字"></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="排序">
        <el-radio-group v-model="filters.orderby" size="small">
          <el-radio-button v-for="item in orders" :value="item.value" :key="item.value" :label="item.value">{{ item.name
          }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" v-on:click="queryAll">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tabs-container">
      <el-tabs v-model="filters.status" @tab-click="typeChange">
        <el-tab-pane label="全部" name="all" key="all"></el-tab-pane>
        <el-tab-pane v-for="tab in tabs" :key="tab.key" :name="tab.key" :label="tab.name">
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-table border :data="datas" style="width: 100%" size="small">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div v-if="scope.row.Labels">
            <el-card class="box-card">
              <div class="item">
                <span style="font-size: 16px">业务标识：</span>
                <el-tag v-for="item in scope.row.Labels.Items" :key="item.Key" type="warning">{{ item.Name }}</el-tag>
              </div>
            </el-card>
          </div>
          <div v-if="scope.row.Attachments">
            <attachmentList :attachments="scope.row.Attachments.Items" />
          </div>
          <div v-if="scope.row.Desc">
            <el-card>
              {{ scope.row.Desc }}
            </el-card>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Code" label="编码" width="100"></el-table-column>
      <el-table-column prop="Name" label="名称" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Category.Name" label="企业分类" width="180">
        <template slot-scope="scope">
          <categorySelector v-if="scope.row.Code != 'HT'" :options="options" style="width: 150px"
            @change="doSave(scope.row)" v-model="scope.row.Category" />
        </template>
      </el-table-column>
      <el-table-column label="企业状态" width="200">
        <template slot-scope="scope">
          <el-radio-group :disabled="scope.row.Code == 'HT'" v-model="scope.row.Status"
            @change="statusChange(scope.row)" size="small">
            <el-radio-button v-for="item in $config.tenantStatus" :value="item.value" :key="item.value"
              :label="item.value">{{ item.name }}</el-radio-button>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column prop="Manager" label="负责人" width="120"></el-table-column>
      <el-table-column prop="Tel" label="电话" width="160">
        <template slot-scope="scope">
          {{ scope.row.Tel }}
          <el-switch size="small" v-model="scope.row.ShowTel" @change="doSave(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="Address" label="地址" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="AdHomeOrder" label="主页推荐位次" width="140">
        <template slot-scope="scope">
          <el-input-number size="small" v-model="scope.row.AdHomeOrder" @change="doSave(scope.row)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="AdChannelOrder" label="频道列表位次" width="140">
        <template slot-scope="scope">
          <el-input-number size="small" v-model="scope.row.AdChannelOrder"
            @change="doSave(scope.row)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button v-if="scope.row.Type != 0" type="text" @click="handleRemove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount" :current-page.sync="pageIndex"></el-pagination>
    </div>
    <div v-if="formVisible">
      <el-dialog v-dragDialog :title="formTitle" :visible.sync="formVisible" width="800px"
        :close-on-click-modal="false">
        <el-form :model="dataForm" ref="dataForm" label-width="120px" :rules="dataFormRules">
          <el-form-item label="企业名称：" prop="Name">
            <el-input v-model="dataForm.Name" auto-complete="off" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="负责人姓名：" prop="Manager">
            <el-input v-model="dataForm.Manager" auto-complete="off" placeholder="请输入负责人姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="Tel">
            <el-input v-model="dataForm.Tel" auto-complete="off" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="联系地址：" prop="Address">
            <el-input v-model="dataForm.Address" auto-complete="off" placeholder="请输入联系地址"></el-input>
          </el-form-item>
          <el-form-item label="企业简介：" prop="Desc">
            <el-input type="textarea" rows="8" v-model="dataForm.Desc" auto-complete="off"
              placeholder="请输入企业简介"></el-input>
          </el-form-item>
          <el-form-item label="图片附件:" prop="Desc">
            <attchmentEditor ref="attchmentEditor" :attachments="dataForm.Attachments"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getSingle,
  getPageList,
  save,
  del,
  changeStatus,
} from "@/api/setting/tenant.js";
import categorySelector from "@/components/categorySelector.vue";
import attachmentList from "@/components/attachmentList.vue";
import attchmentEditor from '@/components/attchmentEditor.vue';
import { getAll } from "@/api/business/category";

export default {
  components: { categorySelector, attachmentList, attchmentEditor },
  data() {
    return {
      orders: [
        { key: 0, name: "入住时间", value: 0 },
        { key: 1, name: "推荐位次", value: 1 },
        { key: 2, name: "频道位次", value: 2 },
      ],
      datas: [],
      filters: {
        search: "",
        status: "all",
        orderby: 0,
      },
      options: [],
      tabs: [],
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      totalCount: 0,
      formVisible: false,
      formTitle: "创建",
      dataForm: {},
      dataFormRules: {
        Name: [
          { required: true, message: "企业名称不能为空", trigger: "change" },
        ],
        Manager: [
          { required: true, message: "负责人不能为空", trigger: "change" },
        ],
        Tel: [
          { required: true, message: "联系电话不能为空", trigger: "change" },
        ],
        Address: [
          { required: true, message: "联系地址不能为空", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    typeChange() {
      this.queryAll();
    },
    getAllCategorys() {
      let param = { type: 8 };
      getAll(param).then((res) => {
        if (res) {
          this.options = res;
        }
      });
    },
    queryAll() {
      let param = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        orderby: this.filters.orderby,
        status: this.filters.status,
      };
      getPageList(param).then((res) => {
        this.datas = res.Items;
        this.totalCount = res.Total | res.Items.length;
      });
    },
    doSave(row) {
      save(row).then((res) => {
        if (res) {
          this.msg.successMsg("保存成功！");
        }
      });
    },
    handleCreate(data) {
      this.formTitle = "新增";
      this.dataForm = {
        Attachments: {
          ItemType: 'HuiTian.Attachment',
          Items: []
        },
      };
      this.formVisible = true;
    },
    handleUpdate(row) {
      this.formTitle = "修改";
      let param = { key: row.Key };
      let that = this;
      getSingle(param).then((res) => {
        that.dataForm = res;
        if (!res.Attachments) {
          this.$set( that.dataForm, 'Attachments', {
            ItemType: 'HuiTian.Attachment',
            Items: []
          })
        }
        that.formVisible = true;
      });
    },
    handleSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(this.dataForm));
          save(param).then((res) => {
            if (res) {
              this.formVisible = false;
              this.queryAll();
            }
          });
        }
      });
    },
    handleRemove(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          key: row.Key,
        };
        del(param)
          .then((res) => {
            if (res) {
              this.queryAll();
            }
          })
          .catch((ex) => { });
      });
    },
    statusChange(row) {
      changeStatus({ key: row.Key, status: row.Status }).then((res) => {
        if (res) {
          this.queryAll();
          this.msg.successMsg("操作成功！");
        }
      });
    },
    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.queryAll();
    },
  },
  mounted() {
    this.tabs = this.$config.tenantStatus;
    this.getAllCategorys();
    this.queryAll();
  },
};
</script>
<style lang='scss' scoped>
.userinfo-container {
  padding: 10px;
}

/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>